import { LoruleRequestConfig } from '@galaxy/lorule-react-commons';
import { callWebUtils, commonHeaders } from './commonApiUtil';
import { StatusChangeRequestItem } from './statusChangeRequestTypes';

export const getStatusChangeRequests = async (config: LoruleRequestConfig) =>
    callWebUtils<Array<StatusChangeRequestItem>>(
        config,
        '/status-change-request',
        'GET',
        null,
        commonHeaders,
    );

export const processRequests = async (
    config: LoruleRequestConfig,
    amIds: number[],
    requestedStatus: string,
    commentMessage?: string | null,
) =>
    callWebUtils(
        config,
        '/status-change-request',
        'PATCH',
        JSON.stringify({
            amIds,
            requestedStatus,
            commentMessage,
        }),
        commonHeaders,
    );

export const cancelRequest = async (
    config: LoruleRequestConfig,
    requestId: number,
    commentMessage?: string | null,
) =>
    callWebUtils(
        config,
        `/status-change-request/${requestId}`,
        'DELETE',
        JSON.stringify({
            commentMessage,
        }),
        commonHeaders,
    );
